import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

export interface TMediaAttachment {
  mediaAttachmentId: string;
  size: number;
  fileName: string;
  uri: string;
  previewUri: string;
  audioDuration: number | null;
  contentType: string;
}

interface FilePreviewStore {
  /**
   * State
   */
  filePreview: {
    file: File | string | TMediaAttachment | null;
    type: 'url' | 'file' | 'null';
  };
  isOpenFilePreviewModal: boolean;

  /**
   * Actions
   */

  actions: {
    setModalFilePreview: (
      isOpen: boolean,
      defaultValues: { file: File | string | TMediaAttachment | null; type: 'url' | 'file' | 'null' }
    ) => void;
    setResetDefaultFileValues: () => void;
  };
}

export const filePreviewStore = create<FilePreviewStore>((set) => ({
  /**
   * State
   */
  filePreview: {
    file: null,
    type: 'null',
  },
  isOpenFilePreviewModal: false,

  /**
   * Actions
   */
  actions: {
    setModalFilePreview: (isOpen, file) => {
      set({ isOpenFilePreviewModal: isOpen, filePreview: { file: file.file, type: file.type } });
    },

    setResetDefaultFileValues: () => {
      set({ filePreview: { file: null, type: 'null' } });
    },
  },
}));

/**
 * Selectors
 * @returns
 */
export const isOpenFilePreviewModal = () => filePreviewStore(useShallow((state) => state.isOpenFilePreviewModal));
export const filePreview = () => filePreviewStore(useShallow((state) => state.filePreview));

/**
 * Actions
 * @returns
 */
export const useFilePreviewActions = () => filePreviewStore(useShallow((state) => state.actions));
